import { action as apiAction } from 'api/Api'
import {
  positionItem,
  addItem,
  removeItem
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  checklistItemId: number
  checklistId: number
  position: number
}

const requestPositionChecklistItem = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, checklistItemId, checklistId, position } = payload

  let currentChecklistId

  const state = getState()

  const elements = state['view-card'].elements[cardId].elements
  const elementsById = state['view-card'].elements.elementsById

  for (let i = 0, length = elements.length; i < length; i++) {
    const checklist = elementsById[elements[i]]

    if (checklist.elementName === '/Data/Checklist' && checklist.items.indexOf(checklistItemId) !== -1) {
      currentChecklistId = checklist.id
      break
    }
  }

  if (checklistId === currentChecklistId) {
    const optimisticAction = optimisticDispatch(dispatch, positionItem({
      elementId: checklistId,
      itemId: checklistItemId,
      index: position
    }))

    try {
      await apiAction('PositionChecklistItem', {
        id: checklistItemId,
        position
      })

      optimisticAction.commit()
    } catch (error) {
      optimisticAction.revert()

      throw error
    }
  } else {
    const optimisticAction = optimisticDispatch(dispatch, [
      removeItem({
        elementId: currentChecklistId,
        itemId: checklistItemId
      }),
      addItem({
        elementId: checklistId,
        itemId: checklistItemId,
        index: position
      })
    ])

    try {
      await apiAction('ChangeChecklistItemParent', {
        containerFromId: currentChecklistId,
        containerToId: checklistId,
        id: checklistItemId,
        position
      })

      optimisticAction.commit()
    } catch (error) {
      optimisticAction.revert()

      throw error
    }
  }
}

export default requestPositionChecklistItem
